import { useEffect, useState, useRef } from "react";
import "./_style.scss";
import TkLoadingIcon from "../TkLoadingIcon";
import { useLocation } from "react-router-dom";
import { useConcatRoutes } from "../../../routes/router";

const TkApiMask = () => {
  const [isMaskVisible, setIsMaskVisible] = useState(false);
  const requestCountRef = useRef(0); // 今行っているAPIリクエストの数
  const timerRef = useRef<NodeJS.Timeout | null>(null); // タイマーリファレンス
  const location = useLocation();
  const path = location.pathname;
  const systemRoute = useConcatRoutes();

  //　エラー画面に遷移する時にマスクを非表示にするための処理
  useEffect(() => {
    const nowRoute = systemRoute.find((r) => r.path === path);
    if (nowRoute?.meta?.isErrorPage) {
      setIsMaskVisible(false);
      requestCountRef.current = 0;
    }
  }, [path, systemRoute]);

  useEffect(() => {
    const handleApiRequestStart = () => {
      requestCountRef.current += 1;

      // リクエスト数が 1 の場合、タイマーをリセットしてマスクを表示
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      setIsMaskVisible(true);
    };

    const handleApiRequestEnd = () => {
      requestCountRef.current = Math.max(0, requestCountRef.current - 1);

      if (requestCountRef.current === 0) {
        // 全てのリクエストが終了した場合、一定時間後にマスクを非表示にする
        const minimumVisibleTime = 300;
        timerRef.current = setTimeout(() => {
          setIsMaskVisible(false);
        }, minimumVisibleTime);
      }
    };

    window.addEventListener("apiRequestStart", handleApiRequestStart);
    window.addEventListener("apiRequestEnd", handleApiRequestEnd);

    return () => {
      window.removeEventListener("apiRequestStart", handleApiRequestStart);
      window.removeEventListener("apiRequestEnd", handleApiRequestEnd);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return isMaskVisible ? (
    <div className="tkApiMask">
      <TkLoadingIcon />
    </div>
  ) : (
    <></>
  );
};

export default TkApiMask;
